module.exports = __webpack_public_path__ + "img/w16-b1.c6d04694.jpg";